// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e8YN","importantInfo":"styles_importantInfo__1UhpD"};